const normalizeNamePart = (part) => part.toLocaleLowerCase()

const getRepeatedSuffixLength = (nameParts) => {
  for (let length = Math.floor(nameParts.length / 2); length >= 1; length -= 1) {
    const firstSuffixStart = nameParts.length - (length * 2)
    const suffixStart = nameParts.length - length
    const matches = nameParts
      .slice(firstSuffixStart, suffixStart)
      .every((part, index) => (
        normalizeNamePart(part) === normalizeNamePart(nameParts[suffixStart + index])
      ))

    if (matches) return length
  }

  return 0
}

export const getCalendarEventDisplayName = (name) => {
  let nameParts = String(name || '').trim().split(/\s+/).filter(Boolean)
  let repeatedSuffixLength = getRepeatedSuffixLength(nameParts)

  while (repeatedSuffixLength > 0) {
    nameParts = nameParts.slice(0, -repeatedSuffixLength)
    repeatedSuffixLength = getRepeatedSuffixLength(nameParts)
  }

  return nameParts.join(' ')
}
